import { useEffect, useState } from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "@/lib/api";

const COLORS = ["#047857", "#d97706", "#2563eb", "#9333ea", "#dc2626"];
const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString(undefined, { month: "short", year: "2-digit" });

export function TrendChart({ state }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/trends", { params: state ? { state } : {} }).then((r) => setD(r.data)); }, [state]);
  if (!d) return <div className="h-80 bg-white border border-slate-200 rounded-lg animate-pulse" />;
  const rows = d.months.map((m) => ({ ...m, label: label(m.month), ...Object.fromEntries([...d.top_states, state].filter(Boolean).map((s) => [s, m.by_state[s] || 0])) }));
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="admin-trend-charts">
      <div className="bg-white border border-slate-200 rounded-lg p-5">
        <div className="font-semibold text-slate-900">Monthly revenue & new users {state && <span className="text-emerald-700">· {state}</span>}</div>
        <div className="h-64 mt-3"><ResponsiveContainer>
          <ComposedChart data={rows}><CartesianGrid stroke="#f1f5f9" vertical={false} /><XAxis dataKey="label" tick={{ fontSize: 11 }} /><YAxis yAxisId="l" tick={{ fontSize: 11 }} tickFormatter={(v) => `$${v}`} /><YAxis yAxisId="r" orientation="right" allowDecimals={false} tick={{ fontSize: 11 }} />
            <Tooltip formatter={(v, n) => (n === "Revenue" ? `$${Number(v).toLocaleString()}` : v)} /><Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar yAxisId="l" dataKey="revenue" name="Revenue" fill="#10b981" radius={[3, 3, 0, 0]} /><Line yAxisId="r" dataKey="new_users" name="New users" stroke="#0f172a" strokeWidth={2} dot={false} />
          </ComposedChart></ResponsiveContainer></div>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-5">
        <div className="font-semibold text-slate-900">New users by top states</div>
        <div className="h-64 mt-3"><ResponsiveContainer>
          <ComposedChart data={rows}><CartesianGrid stroke="#f1f5f9" vertical={false} /><XAxis dataKey="label" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} tick={{ fontSize: 11 }} /><Tooltip /><Legend wrapperStyle={{ fontSize: 12 }} />
            {(state ? [state] : d.top_states).map((s, i) => <Line key={s} dataKey={s} stroke={COLORS[i]} strokeWidth={2} dot={false} />)}
          </ComposedChart></ResponsiveContainer></div>
        {!d.top_states.length && <p className="text-xs text-slate-400">No users have set a state yet.</p>}
      </div>
    </div>
  );
}
